// Generated by scripts/mdi/import-questionnaires.mjs from MDI "B12 Injection Intake 09.17.26" (d8dad262-6085-4f18-a384-f7dcdbae968e). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiB12InjectionIntakeQuestions = [
  {
    field: 'mdiB12InjectionIntake_hereEvaluatedMedicationHelpProvide',
    label:
      'Are you here to be evaluated for medication to help provide supplementation for your diet and exercise plan?',
    type: 'select',
    educationalSlide:
      'All responses will be evaluated by a board-certified physician.  Medication may be prescribed for appropriate candidates.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '6b6ff26d-043b-488b-a9b5-b4c65a74f07e' }
  },
  {
    field: 'mdiB12InjectionIntake_kidneyDiseaseLiverDiseaseCirrhosis',
    label:
      "Do you have kidney disease, or liver disease/cirrhosis, or Leber's disease",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '59e0e96c-a712-4d38-bbf6-d86efd78e4bc' }
  },
  {
    field: 'mdiB12InjectionIntake_suffer',
    label: 'Do you suffer from any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'fatigue', value: 'Fatigue' },
        { key: 'slow_metabolism', value: 'Slow metabolism' },
        { key: 'abnormal_sleep_patterns', value: 'Abnormal sleep patterns' },
        { key: 'immunocompromised', value: 'Immunocompromised' },
        {
          key: 'currently_undergoing_weight_loss_treatme',
          value: 'Currently undergoing weight loss treatment'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '91ecbccf-38ac-4035-a9c8-813567ca1485' }
  },
  {
    field: 'mdiB12InjectionIntake_historyBariatricSurgery',
    label: 'Do you have any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'history_of_bariatric_surgery',
          value: 'History of bariatric surgery'
        },
        {
          key: 'history_of_bowel_resection',
          value: 'History of bowel resection'
        },
        { key: 'short_gut_syndrome', value: '"Short-gut syndrome"' },
        {
          key: 'history_of_b12_deficiency',
          value: 'History of B12 deficiency'
        },
        { key: 'lebers_disease', value: "Leber's Disease" },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '825274f3-5540-4953-9f90-b00d4239e2da' }
  },
  {
    field: 'mdiB12InjectionIntake_urgentDueHavingLebersDisease',
    label:
      "URGENT: Due to having Leber's Disease, you are not medically cleared to use this medication.",
    type: 'info',
    subLabel:
      'Please contact your Neurologist or Eye Doctor ASAP. Do not take this medication.&#160;',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'eb7e699d-dfd7-439b-a2a0-e0b304ee3b99',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiB12InjectionIntake_understandQuestionsWereAsked',
    label: 'Do you understand all the questions which were asked?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '4c4b35e7-fcda-4e12-86c3-e25b1d6cf798' }
  },
  {
    field: 'mdiB12InjectionIntake_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent   (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiB12InjectionIntake_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'f207fe3c-8180-486c-a839-5ab1a2ad967b' }
  },
  {
    field: 'mdiB12InjectionIntake_elseLikeTellDoctorWho',
    label:
      'What else would you like to tell the doctor who will be evaluating you?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiB12InjectionIntake_elseLikeTellDoctorWho',
      rows: 4,
      placeholder: 'Example:  "Nothing else"'
    },
    extras: { mdiQuestionId: '8c720ec0-2a08-4521-98fd-781500cd1df7' }
  },
  {
    field: 'mdiB12InjectionIntake_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiB12InjectionIntakeAnswerField = Partial<
  QuestionAnswerMap<typeof mdiB12InjectionIntakeQuestions>
>;

export default mdiB12InjectionIntakeQuestions;
